import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-guide',
  templateUrl: './guide.component.html',
  styleUrls: ['./guide.component.scss']
})
export class GuideComponent implements OnInit {
  @Input() exibirPopup: boolean = false;
  @Input() exibirPopupPerfil: boolean = false;
  @Input() nome: string = "";
  @Output() controleExibicao = new EventEmitter<boolean>();

  public id: number = 0;

  constructor(
  ) { }
  ngOnInit(): void {
  }

  proximo() {
    if (this.id < 3) {
      this.id += 1;
    }
  }

  resetarId(): void {
    this.id = 0;
  }

  fecharPopup(): void {
    this.controleExibicao.emit(false);
  }
}
